import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProgressReportService {
  private isVisibleSubject = new BehaviorSubject<boolean>(false);
  private isReportingSubject = new BehaviorSubject<boolean>(false);

  isVisible$ = this.isVisibleSubject.asObservable();
  isReporting$ = this.isReportingSubject.asObservable();

  constructor() {}

  show(): void {
    this.isVisibleSubject.next(true);
  }

  hide(): void {
    this.isVisibleSubject.next(false);
  }

  busyReporting(): void {
    this.isReportingSubject.next(true);
  }

  endReporting(): void {
    this.isReportingSubject.next(false);
  }
}
